import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class TitleService {

    private defaultTitle = 'TMS';

    constructor(private title: Title) { }

    // Phương thức để cập nhật tiêu đề trang
    setTitle(newTitle?: string): void {
        if (newTitle) {
            if (newTitle == "TMS") {
                this.title.setTitle(newTitle);
            } else {
                this.title.setTitle(`TMS | ${newTitle}`);
            }
        } else {
            this.title.setTitle(this.defaultTitle);
        }
    }
}